import React from "react";
import { Button } from "../Button/Button";
import { usePagination } from "react-instantsearch";
import { PaginationConnectorParams } from "instantsearch.js/es/connectors/pagination/connectPagination";

type PaginationProps = {
  children: any;
  className: string;
  showNextText: string;
  showPreviousText: string;
  numberOfHits: number;
  scrollToStart: any;
  [x: string]: any;
};

export const QuickPagination: React.FC<any> = ({
  children,
  className,
  showNextText,
  showPreviousText,
  numberOfHits,
  scrollToStart,
  ...props
}: PaginationProps & PaginationConnectorParams) => {
  const { currentRefinement, nbPages, refine } = usePagination(
    props as PaginationConnectorParams
  );

  const showPrevious = () => {
    refine(currentRefinement - 1);
    scrollToStart();
  };

  const showNextHits = () => {
    refine(currentRefinement + 1);
    scrollToStart();
  };

  return numberOfHits > 3 ? (
    <>
      <Button
        rounded
        className={className}
        variant="transparent"
        onClick={showPrevious}
        disabled={currentRefinement === 0}
      >
        Show previous
      </Button>
      <Button
        rounded
        className={className}
        variant="transparent"
        onClick={showNextHits}
        disabled={currentRefinement === nbPages}
      >
        {children}
      </Button>
    </>
  ) : (
    <></>
  );
};
